module.exports = __webpack_public_path__ + "static/media/Michelle Walker.8beec989.png";